webpackJsonp([48],{

/***/ 0:
/***/ (function(module, exports) {


var isIE = function isIE() {
	return !!window.ActiveXObject || "ActiveXObject" in window;
},
    ltIE9 = function ltIE9() {
	var browser = navigator.appName,
	    b_version = navigator.appVersion,
	    version = b_version.split(";");

	if (version.length > 1) {
		var trim_Version = parseInt(version[1].replace(/[ ]/g, "").replace(/MSIE/g, ""));
		if (trim_Version < 9) {
			return true;
		}
	}

	return false;
},
    loadAsync = function loadAsync(src, callback) {
	if (typeof src === 'string') {
		src = [src];
	}

	for (var i = 0; i < src.length; i++) {
		var script = document.createElement('script');
		script.src = src[i];

		if (callback && $.type(callback) === 'function' && i + 1 === src.length) {
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' || script.readyState === 'complete') {
					callback();
				}
			};
		}
		document.body.appendChild(script);
	}
},
    queryString = function queryString(name, targetStr) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r;
	if (!targetStr) {
		r = window.location.search.substr(1).match(reg);
	} else {
		r = targetStr.match(reg);
	}
	return r != null ? unescape(r[2]) : null;
},
    addDays = function addDays(d1, num, sep) {
	sep = sep || '-';
	num = num || 0;
	if (typeof d1 === 'string') d1 = new Date(d1.replace(/-/g, '/'));
	return new Date(+d1 + num * 24 * 60 * 60 * 1000).Format('yyyy' + sep + 'MM' + sep + 'dd');
},
    throttle = function throttle(func, option, timeGap, context) {

	timeGap = timeGap || 300;

	clearTimeout(func.tId);

	func.tId = setTimeout(function () {
		func.call(context, option);
	}, timeGap);
},
    login = function login() {
	location.href = '/user/home.do';
},
    tipShowAndHide = function tipShowAndHide(_this, msg, options) {
	var tip = layer.tips(msg, _this, $.extend(true, {
		time: 0,
		tips: [1, '#FFFFF3']
	}, options));

	_this.one('mouseleave', function () {
		layer.close(tip);
	});
},
    formatOne = function formatOne(str) {
	return str.replace(/\//g, '-');
},
    CloseWebPage = function CloseWebPage() {
	if (navigator.userAgent.indexOf("MSIE") > 0) {
		if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
			window.opener = null;
			window.close();
		} else {
			window.open('', '_top');
			window.top.close();
		}
	} else if (navigator.userAgent.indexOf("Firefox") > 0) {
		window.location.href = 'about:blank ';
	} else {
		window.opener = null;
		window.open('', '_self', '');
		window.close();
	}
};

module.exports = {
	isIE: isIE,
	ltIE9: ltIE9,
	login: login,
	addDays: addDays,
	loadAsync: loadAsync,
	queryString: queryString,
	throttle: throttle,
	tipShowAndHide: tipShowAndHide,
	formatOne: formatOne,
	CloseWebPage: CloseWebPage
};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {


window.Promise = __webpack_require__(23);

__webpack_require__(4);
__webpack_require__(294);

__webpack_require__(5).run();

__webpack_require__(295).run();

__webpack_require__(296).run();

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {


function carousel() {
	var carouselVal = null;

	var outerW = $('.banner').width();
	function carouselFn() {
		var index = 0;
		carouselVal = setInterval(function () {
			if (index == 0) {
				index = 1;
			} else if (index == 1) {
				index = 2;
			} else {
				index = 0;
			}

			$('.banner-point>li').eq(index).addClass('this-point').siblings().removeClass('this-point');
		}, 3000);
	}

	carouselFn();

	$('.banner-image').mouseenter(function () {
		clearInterval(carouselVal);
	}).mouseleave(function () {
		carouselFn();
	});

	$('.banner-point>li').click(function () {
		clearInterval(carouselVal);

		$(this).addClass('this-point').siblings().removeClass('this-point');

		$('.banner-image>li').eq($(this).attr('pindex')).fadeIn('slow').siblings().fadeOut();
	});
}

function partner() {
	$('.pre-partner-box').mouseenter(function (e) {
		var _index = $(this).attr('p-index');
		$(this).closest('.partner').find('.pre-partner-bg').removeClass('pre-partner-bg-hover').eq(_index - 1).addClass('pre-partner-bg-hover');
	}).mouseleave(function () {
		$(this).closest('.partner').find('.pre-partner-bg').removeClass('pre-partner-bg-hover');
	});
}

function navbar() {
	$('.navbar-right .nav-tab').click(function () {
		$('.nav-tab').removeClass('selected-nav');
		$(this).addClass('selected-nav');
	});
}

function other() {
	$('.yzm-img').click(function () {
		$(this).attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
	});
}

module.exports = {
	run: function run() {
		partner();

		carousel();

		navbar();

		other();
	}
};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {


var hasLoginTmp = __webpack_require__(297);

var firstPageApi = {
	login: '/user/loginfzg.do',
	isLogin: '/user/getCurrentUser.do',
	loginout: '/user/loginoutfzg.do'
};

function isLogin() {
	$.get(firstPageApi.isLogin, function (data) {
		if (data.returnCode == 1) {
			$('.login-background,.login-box').hide();

			var hasLoginStr = hasLoginTmp(data.data);
			$('.banner').append(hasLoginStr);

			$('.application,.service-apply').attr('href', '/webpackBasedProject/webpacked/html/joinUs.html?id=joinUs_1&isLogin=true');
			sessionStorage.setItem('login', 'login');

			$('.banner').delegate('.login-out', 'click', function () {
				layer.confirm('确认退出登录？', function () {
					$.get(firstPageApi.loginout, function (data) {
						if (data.returnCode == 1) {
							$('.application,.service-apply').attr('href', '/webpackBasedProject/webpacked/html/joinUs.html?id=joinUs_1&isLogin=false');
							sessionStorage.removeItem('login');
							layer.msg('退出成功', { time: 500 }, function () {
								location.reload();
							});
						} else {
							alert(data.returnMsg, { closeBtn: 0 }, function () {
								location.reload();
							});
						}
					});
				});
			});
		} else {}
	});

	if (getCookie('login_account_code_cookie')) {
		$('input[name="accountCode"]').val(getCookie('login_account_code_cookie'));
		$('input[name="username"]').val(decodeURIComponent(getCookie('login_user_name_cookie')));
		$('input[name="rememberMe"]').attr('checked', 'true');
	}
}

function getCookie(name) {
	var strcookie = document.cookie;
	var arrcookie = strcookie.split("; ");
	for (var i = 0; i < arrcookie.length; i++) {
		var arr = arrcookie[i].split("=");
		if (arr[0] == name) {
			return arr[1];
		}
	}
	return "";
}

function loginJl() {
	$('#loginIn').click(function () {
		$('.err-msg').text('');

		$(this).text('登录中…');

		var allInput = $('#loginJl').find('input[emptymsg]');

		var loginFlag = "true";
		for (var aI = 0; aI < allInput.length; aI++) {
			var $requireInput = $(allInput[aI]);
			if (!$requireInput.val()) {
				loginFlag = "false";
				$('.err-msg').text($requireInput.attr('emptymsg'));
				$(this).text('登录');
				break;
			}
		}

		if (loginFlag == "true") {
			var rememberMe = '';
			if ($('input[name="rememberMe"]').is(':checked')) {
				rememberMe = 'true';
			} else {
				rememberMe = 'false';
			}
			var paramObj = {
				accountCode: $.trim($('input[name="accountCode"]').val()),
				username: $.trim($('input[name="username"]').val()),
				password: $('input[name="password"]').val(),
				checkcode: $('input[name="checkcode"]').val(),
				rememberMe: rememberMe
			};

			$.post(firstPageApi.login, paramObj, function (data) {
				if (data.returnCode) {
					if (data.returnCode != 1) {
						$('.err-msg').text(data.returnMsg);
						$('.yzm-img').trigger('click');
						$('#loginIn').text('登录');
					} else {
						if ($.trim(paramObj.accountCode).length > 0) {
							var record_data = encodeURIComponent(paramObj.accountCode.toUpperCase());
							$.get("/count/record.do?t=ActiveDistrb&d=" + record_data);
						}

						var loginAccount = localStorage.getItem("LoginAccount");
						if (!loginAccount || loginAccount != paramObj.accountCode) {
							localStorage.setItem("LoginAccount", paramObj.accountCode);
						}
						var LoginUsername = localStorage.getItem("LoginUsername");
						if (!LoginUsername || LoginUsername != paramObj.username) {
							localStorage.setItem("LoginUsername", paramObj.username);
						}

						$('.application,.service-apply').attr('href', '/webpackBasedProject/webpacked/html/joinUs.html?id=joinUs_1&isLogin=true');
						sessionStorage.setItem('login', 'login');

						$('.login-background,.login-box').hide();

						var hasLoginStr = hasLoginTmp(data.data);
						$('.banner').append(hasLoginStr);

						if (data.data.request_old_url_key && data.data.request_old_url_key !== '' && data.data.request_old_url_key !== undefined) {
							location.href = data.data.request_old_url_key;
						} else {
							location.href = '/user/bookHotel.do';
						}
					}
				} else {
					alert('系统繁忙，请稍后重试');
					$('#loginIn').text('登录');
				}
			});
		}

		return false;
	});
}

function isLoginFzg() {
	$('.to-fzg').on('click', function () {
		$.get(firstPageApi.isLogin, function (data) {
			if (data.returnCode == 1) {
				location.href = '/user/bookHotel.do';
			} else {
				var promptBoxTmpl = __webpack_require__(298);
				var promptBoxDOM = layer.open({
					type: 1,
					title: false,
					area: '530px',
					move: '.palce-can-move',
					content: promptBoxTmpl(data)
				});

				$(document).delegate('.see-soon,.prompt-yes', 'click', function () {
					layer.close(promptBoxDOM);
				});

				$(document).delegate('.login-now', 'click', function () {
					layer.close(promptBoxDOM);

					$('body, html').animate({
						scrollTop: 0
					}, 200);
				});
			}
		});
	});
}

module.exports = {
	run: function run() {
		isLogin();

		loginJl();
	}
};

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="has-login-bg"></div>\n<div class="has-login-box">\n    <span class="company-name">' +
((__t = ( distributorAccount.distrbName )) == null ? '' : __t) +
'</span>\n    <div class="user-name-status">\n        <div class="status1 clearfix">\n            <span class="user-name">' +
((__t = ( user.customerUserName )) == null ? '' : __t) +
'</span>\n            <p class="user-status">\n                ';
 if (user.station != '请选择'){ ;
__p += '\n                (' +
((__t = ( user.station )) == null ? '' : __t) +
')\n                ';
 } ;
__p += '\n            </p>\n        </div>\n        <div class="status2 clearfix">\n            <p class="user-balance">余额：<span class="balance-acount">￥' +
((__t = ( distributorAccount.balance )) == null ? '' : __t) +
'</span></p>\n            <!--<a href="/charge/userCharge.do?chargeType=charge" class="recharge" data-track="企业首页_登录框_快速充值">快速充值&gt;</a>-->\n            <a href="/pay/toPayOrCharge.do?payMethod=0" class="recharge" data-track="企业首页_登录框_快速充值">快速充值&gt;</a>\n        </div>\n    </div>\n    <a href="/user/bookHotel.do" class="go-fzg" data-track="企业首页_登录框_进入房掌柜">进入房掌柜</a>\n    <a class="login-out" href="javascript:void(0)" data-track="企业首页_退出登录">退出登录</a>\n</div>\n';

}
return __p
}

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (returnCode == -400001){ ;
__p += '\r\n<div class="prompt-box">\r\n    <h6 class="prompt-head">您还未登录房掌柜</h6>\r\n    <p class="prompt-text">请先登录后再重新操作</p>\r\n    <div class="btns">\r\n        <button class="see-soon">稍后再说</button>\r\n        <button class="login-now">现在登录</button>\r\n    </div>\r\n</div>\r\n';
 }else{ ;
__p += '\r\n<div class="prompt-box">\r\n    <h6 class="prompt-head">' +
((__t = ( returnMsg )) == null ? '' : __t) +
'</h6>\r\n    <button class="prompt-yes">确定</button>\r\n</div>\r\n';
 } ;


}
return __p
}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(6);

var Util = __webpack_require__(0);

module.exports = {
    run: function run() {
        if (Util.ltIE9()) {
            alert('为了更好的使用体验，请不要使用IE浏览器，谢谢！');
        }
    }
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[293]);


// WEBPACK FOOTER //
// js/firstPage/firstPage.2dee1fd79c79c5922e50.js